import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Partner } from "../../types/partner";

interface PartnersState {
  items: Partner[];
  fetchedAt: number | null;
}

const initialState: PartnersState = {
  items: [],
  fetchedAt: null,
};

export const partners = createSlice({
  name: "partners",
  initialState,
  reducers: {
    setPartners: (state, action: PayloadAction<Partner[]>) => {
      state.items = action.payload;
    },
    upsertPartner: (state, action: PayloadAction<Partner>) => {
      const index = state.items.findIndex(
        (partner) => partner.partner_id === action.payload.partner_id
      );
      if (index === -1) {
        state.items = [action.payload, ...state.items];
      } else {
        state.items[index] = {
          ...state.items[index],
          ...action.payload,
        };
      }
    },
    removePartner: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(
        (partner) => partner.partner_id !== action.payload
      );
    },
    setPartnersFetchedAt: (state, action: PayloadAction<number | null>) => {
      state.fetchedAt = action.payload;
    },
    clearPartners: (state) => {
      state.items = [];
      state.fetchedAt = null;
    },
  },
});

export const {
  setPartners,
  upsertPartner,
  removePartner,
  setPartnersFetchedAt,
  clearPartners,
} = partners.actions;

export default partners.reducer;
